import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, Location, CurrencyPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ZoomDetail } from '../models/zoom-detail.model';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';

@Component({
    selector: 'app-zoom-detail',
    templateUrl: './zoom-detail.component.html',
    styleUrls: ['./zoom-detail.component.css'],
    imports: [MrpScrolltopComponent, CurrencyPipe]
})
export class ZoomDetailComponent implements OnInit {

  zoom: ZoomDetail | null = null;
  displayedColumns: string[] = ['name', 'description', 'action'];
  isLoading = false;
  isInitiatingCheckout = false;
  item_CODE: string | null = null;
  isBrowser = false;

  constructor(private route: ActivatedRoute, private http: HttpClient, 
    private location: Location, @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    this.item_CODE = this.route.snapshot.paramMap.get('code');

    this.isLoading = true;
    if (this.isBrowser) {
      this.http.post<ZoomDetail[]>('api/products/getZoomDetails.php', {"item_CODE": this.item_CODE}).subscribe({
            next: (data) => {
              this.zoom = data[0];
              // normalize incoming data so templates receive consistent object arrays
              if (this.zoom) {
                this.zoom.product_descriptions = this.normalizeProductDescriptions(this.zoom.product_descriptions);
                this.zoom.topics = this.normalizeTopics(this.zoom.topics);
              }
              this.isLoading = false;
              this.cdr.markForCheck();
            },
            error: (error) => {
              console.error('Error fetching products:', error);
              this.isLoading = false;
              this.cdr.markForCheck();
            }
          });   
      this.logPage(this.route.snapshot.url.join('/'));
    } else {
      // Avoid server-side HTTP calls during prerender
      this.isLoading = false;
    }

  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }

  goBack(): void {
    this.location.back();
  }

  private normalizeProductDescriptions(pd: any): { description: string }[] {
    if (!pd) return [];
    if (Array.isArray(pd)) {
      if (pd.length === 0) return [];
      if (typeof pd[0] === 'string') return (pd as string[]).map(s => ({ description: s }));
      return pd as { description: string }[];
    }
    if (typeof pd === 'string') return [{ description: pd }];
    return [];
  }

  private normalizeTopics(t: any): { topic: string }[] {
    if (!t) return [];
    if (Array.isArray(t)) {
      if (t.length === 0) return [];
      if (typeof t[0] === 'string') return (t as string[]).map(s => ({ topic: s }));
      return t as { topic: string }[];
    }
    if (typeof t === 'string') return [{ topic: t }];
    return [];
  }

  async initiateCheckout(priceId?: string, mode: 'payment' = 'payment') {
    if (!priceId) {
      console.error('Missing priceId for checkout');
      return;
    }

    this.isInitiatingCheckout = true;
      this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string}>('api/create-checkout-session/create-checkout-session.php', { priceId, mode }).subscribe({
        next: async (response) => {
          // Now use the actual Stripe instance
          if (response) {
            window.location.assign(response.sessionUrl);
          } else {
            console.error('Failed to load Stripe');
            this.isInitiatingCheckout = false;
            this.cdr.markForCheck();
          }
        },
        error: (error) => {
          this.isInitiatingCheckout = false;
          console.error('Error creating checkout session:', error);
          this.cdr.markForCheck();
        }
      });

  }

}
